import React from 'react';
import { Row, Col } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { EmailFieldFormatter } from '../FieldFormatter/EmailFieldFormatter';
import { PhoneFieldFormatter } from '../PhoneFieldFormatter/PhoneFieldFormatter';

export const EmailPhoneInput = ({
  name,
  emailValue,
  phoneValue,
  emailCallback,
  phoneCallback
}) => {

  return (
    <Row>
      <Col fallback={12} xs={6} sm={6} md={6} lg={6}>
        <EmailFieldFormatter
          name={name}
          callback={emailCallback}
          value={emailValue}
        />
      </Col>
      <Col fallback={12} xs={6} sm={6} md={6} lg={6}>
        <PhoneFieldFormatter
          name={name}
          callback={phoneCallback}
          value={phoneValue}
        />
      </Col>
    </Row>
  );
};

EmailPhoneInput.displayName = 'emailPhoneInput';

EmailPhoneInput.propTypes = {
  emailValue: PropTypes.string.isRequired,
  phoneValue: PropTypes.string.isRequired,
  emailCallback: PropTypes.func.isRequired,
  phoneCallback: PropTypes.func.isRequired,
  name: PropTypes.string
};

EmailPhoneInput.defaultProps = {
  name: 'input'
};
